import { HttpStatusCodes } from "../../services/SystemNames"
import { formatForSave } from "./DateTimeHelpers";

function hasResponseNoContent(response) {
    return response.status === HttpStatusCodes.NoContent;
}

export const prepareObjectForApi = (obj) => {
    for (const key in obj) {
        if (obj[key] instanceof Date) {
            obj[key] = formatForSave(obj[key]);
        }
    }
}

export const isRequestAborted = (response) => {
    if ('aborted' in response) {
        return response.aborted;
    }
    return false;
}

export {
    hasResponseNoContent
}
